
function getStorage(): Storage | null {
  try {
    if (typeof localStorage === 'undefined' || localStorage === null) {
      return null;
    }
    return localStorage;
  } catch {
    return null;
  }
}

export function safeGetItem(key: string): string | null {
  const store = getStorage();
  if (!store) {
    return null;
  }
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key: string, value: string): boolean {
  const store = getStorage();
  if (!store) {
    return false;
  }
  try {
    store.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeRemoveItem(key: string): boolean {
  const store = getStorage();
  if (!store) {
    return false;
  }
  try {
    store.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function isStorageAvailable(): boolean {
  return getStorage() !== null;
}
